import { render } from "./resource-administration.vue?vue&type=template&id=2a16f59b&scoped=true"
import script from "./resource-administration.vue?vue&type=script&lang=js"
export * from "./resource-administration.vue?vue&type=script&lang=js"

import "./resource-administration.vue?vue&type=style&index=0&id=2a16f59b&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a16f59b"]])

export default __exports__